export default __webpack_public_path__ + "static/media/Deezer_Logo_RVB_Black.e7a55391.svg";